<template>
  <div>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense color="secondary" dark>
          <v-toolbar-title>Customer Feedback</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- FILTER -->
        <v-flex xs12 sm12 lg12>
          <v-card elevation-5 dark>
            <v-card-title class="title">Filters</v-card-title>
            <v-layout ma-2>
              <v-flex lg6 xs6 sm6 mr-2>
                <v-combobox
                  v-model="selectedOpsManager"
                  label="Select ops-manager"
                  :items="opsManagerList"
                  item-text="FullName"
                  item-value="ID"
                  @change="checkSelectedOpsManager()"
                  :disabled="opsManagerList.length == 0"
                ></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="startDateFormatted"
                      label="Start Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      @blur="startDate = parseStartDate(startDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu
                  ref="menu1"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="endDateFormatted"
                      label="End Date"
                      hint="MM/DD/YYYY format"
                      persistent-hint
                      prepend-icon="event"
                      @blur="endDate = parseEndDate(endDateFormatted)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <!-- <v-date-picker v-model="endDate" no-title @input=""> -->
                  <v-date-picker v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout justify-end ma-2 row>
              <download-excel
                ref="downloadExcelRef"
                style="height:0px; opacity:0;"
                :data="excelData"
                :fields="excelFields"
                :name="fileName"
              ></download-excel>
              <v-btn flat outline @click="filterItems()">Filter</v-btn>
              <v-btn flat outline @click="clearFilter()">Clear Filter</v-btn>
              <v-btn flat outline @click="triggerExcel()">Export</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
        <v-layout row wrap ma-2>
          <v-layout ma-2>
            <v-flex xs3>
              <h3>Customer Feedback</h3>
            </v-flex>
          </v-layout>
          <v-container>
            <v-layout mr-2>
              <v-spacer></v-spacer>
              <v-flex xs4>
                <v-text-field
                  append-icon="search"
                  v-model="search"
                  placeholder="Search customer feedback"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-flex d-flex lg12 sm12 xs12>
              <v-data-table
                class="table"
                :headers="customerFeedbackHeaders"
                :items="customerFeedbackItems"
                :rows-per-page-items="[50, 75, 100]"
                :search="search"
              >
                <template v-slot:items="props">
                  <td>{{ props.index+1 }}</td>
                  <td class="text-xs-left">{{ props.item.DateSent }}</td>
                  <td class="text-xs-left">{{ props.item.CustomerName }}</td>
                  <td class="text-xs-left">{{ props.item.SystemUserFullName }}</td>
                  <td class="text-xs-left">{{ props.item.TypeName }}</td>
                  <td class="text-xs-left">{{ props.item.StatusName }}</td>
                  <td class="text-xs-left">{{ props.item.Comments }}</td>
                  <td class="text-xs-left">{{ props.item.ResolvedComments }}</td>
                  <td class="text-xs-left">{{ props.item.DateResolved }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import Widget from "./Widget.vue";
import DataTable from "./DataTable.vue";
import TimeLine from "./TimeLine.vue";
import LocationStatistic from "./LocationStatistic.vue";
import SiteViewStatistic from "./SiteViewStatistic.vue";
import TotalEarningsStatistic from "./TotalEarningsStatistic.vue";
import moment from "moment";
import JWT from "jsonwebtoken";

export default {
  data() {
    return {
      tmp: [],
      selectedOpsManager: null,
      opsManagerList: [],
      role: null,
      userID: 0,
      startDate: null,
      endDate: null,
      startDateFormatted: this.formatStartDate(
        new Date().toISOString().substr(0, 10)
      ),
      endDateFormatted: this.formatEndDate(
        new Date().toISOString().substr(0, 10)
      ),
      menu1: false,
      menu2: false,
      CheckInsForToday: 0,
      today: moment(Date.now()).format("YYYY-MM-DD"),
      customerItems: [],
      selectedCustomer: null,
      venueItems: [],
      selectedVenue: null,
      customerFeedbackItems: [],
      search: null,
      customerFeedbackHeaders: [
        {},
        {
          value: "Date Sent",
          text: "DateSent",
          align: "left",
          sortable: true
        },
        {
          text: "From Customer",
          value: "CustomerName",
          align: "left",
          sortable: true
        },
        {
          text: "For Ops Manager",
          value: "SystemUserFullName",
          align: "left",
          sortable: true
        },
        {
          text: "Feedback Type",
          value: "TypeName",
          align: "left",
          sortable: true
        },
        {
          text: "Status",
          value: "StatusName",
          align: "left",
          sortable: true
        },
        {
          text: "Customer Comments",
          value: "Comments",
          align: "left",
          sortable: true
        },
        {
          text: "Resolved Comments",
          value: "ResolvedComments",
          align: "left",
          sortable: true
        },
        {
          text: "Date Resolved",
          value: "DateResolved",
          align: "left",
          sortable: true
        }
      ],
      excelFields: {
        "Ops Manager": "DateSent",
        Customer: "CustomerName",
        "For Ops Manager": "SystemUserFullName",
        "Feedback Type": "TypeName",
        Status: "StatusName",
        "Customer Comments": "Comments",
        "Resolved Comments": "ResolvedComments",
        "Date Resolved": "DateResolved"
      },
      excelData: [],
      fileName: null
    };
  },
  components: {
    Widget,
    DataTable,
    TimeLine,
    LocationStatistic,
    SiteViewStatistic,
    TotalEarningsStatistic
  },
  computed: {
    computedDateFormatted() {
      return this.formatStartDate(this.startDate);
      return this.formatEndDate(this.endDate);
    }
  },
  watch: {
    startDate(val) {
      this.startDateFormatted = this.formatStartDate(this.startDate);
    },
    endDate(value) {
      this.endDateFormatted = this.formatEndDate(this.endDate);
    }
  },
  mounted() {
    let self = this;
    let tokenDecoded = JWT.decode(localStorage.accessToken);
    console.log("[TOKEN DECODED]", tokenDecoded);

    self.userID = localStorage.getItem("USER_ID");
    console.log("USER_ID", self.userID);
    self.role = localStorage.getItem("Role");
    console.log("ROLE", self.role);

    var date = new Date();
    self.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
      .toISOString()
      .substr(0, 10);
    self.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .toISOString()
      .substr(0, 10);

    self.FetchOpsManagers();
    // self.FetchCustomerTasks();
  },
  methods: {
    FetchCustomerTasks() {
      let self = this;
      self.customerFeedbackItems = [];
      self
        .get(
          `CustomerFeedbackTask/GetAll?startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          console.log("[ALL CUSTOMER FEEDBACK TASKS]", r.data);
          r.data.forEach(feedback => {
            if (
              feedback.DateResolved == null ||
              feedback.DateResolved == "Invalid date" ||
              feedback.DateResolved == undefined
            ) {
              feedback.DateResolved = "This has not yet been resolved.";
              feedback.ResolvedComments = "This has not yet been resolved.";
            } else {
              feedback.DateResolved = moment(feedback.DateResolved).format(
                "YYYY-MM-DD hh:mm:ss"
              );
            }

            feedback.DateSent = moment(feedback.DateSent).format(
              "YYYY-MM-DD hh:mm:ss"
            );
            self.customerFeedbackItems.push(feedback);
          });
        });
    },
    FetchOpsManagers() {
      let self = this;

      self.get(`SystemUser/GetOpsManagers`).then(r => {
        console.log("[Ops-manager LIST]", r.data);
        self.opsManagerList = r.data;

        self.FetchCustomerTasks();
      });
    },
    checkSelectedOpsManager() {
      let self = this;

      self.$nextTick(() => {
        console.log("selected ops-manager", self.selectedOpsManager);
      });
    },
    FetchForOps() {
      let self = this;

      self.customerFeedbackItems = [];
      self
        .get(
          `CustomerFeedbackTask/GetByOpsManager?userID=${self.selectedOpsManager.ID}&startDate=${self.startDate}&endDate=${self.endDate}`
        )
        .then(r => {
          r.data.forEach(feedback => {
            if (
              feedback.DateResolved == null ||
              feedback.DateResolved == "Invalid date"
            ) {
              feedback.DateResolved = "This has not yet been resolved.";
              feedback.ResolvedComments = "This has not yet been resolved.";
            } else {
              feedback.DateResolved = moment(feedback.DateResolved).format(
                "YYYY-MM-DD hh:mm:ss"
              );
            }

            feedback.DateSent = moment(feedback.DateSent).format(
              "YYYY-MM-DD hh:mm:ss"
            );
            self.customerFeedbackItems.push(feedback);
          });
        });
    },
    filterItems() {
      let self = this;
      if (self.selectedOpsManager.ID != null) {
        self.$refs.Loader.show(true);
        self.$refs.Loader.setText("Filtering items...");
        console.log("SELECTED DATES", self.startDate, self.endDate);
        self.menu2 = false;
        self.FetchForOps();
        setTimeout(() => {
          self.$refs.Loader.hide();
        }, 2000);
      }
    },
    clearFilter() {
      let self = this;
      self.customerFeedbackItems = [];
      self.selectedOpsManager = null;
    },
    triggerExcel() {
      let self = this;

      self.fileName = "Customer-Feedback-Tasks-" + self.today;
      self.excelData = self.customerFeedbackItems;
      var vueJsonExcel = self.$refs.downloadExcelRef;
      vueJsonExcel.$el.click();
    },
    // DATE FILTERING
    parseDate(date) {
      let self = this;
      console.log("PARSED DATE", date);
    },
    filterByDate() {
      let self = this;
      var labels = [];
      var data = [];

      console.log("[FILTER START DATE]", self.startDate);
      console.log("[FILTER END DATE]", self.endDate);
    },
    formatStartDate(startDate) {
      if (!startDate) return null;

      const [year, month, day] = startDate.split("-");
      return `${month}/${day}/${year}`;
    },
    formatEndDate(endDate) {
      if (!endDate) return null;

      const [year, month, day] = endDate.split("-");
      return `${month}/${day}/${year}`;
    },
    parseStartDate(startDate) {
      if (!startDate) return null;

      const [month, day, year] = startDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseEndDate(endDate) {
      if (!endDate) return null;

      const [month, day, year] = endDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style>
</style>